module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAARJJREFUeNqMkr1qQkEQhfduTJT8gBZiiAj6DqkkZV4mL2CfJ7CxF9Klt0mvVhZKChuxTG5CkIQEjb835+BZWPTKzcDH7M7MgZnZDQqdccEYc2a2lgJ1UNL9B9yBb93nLOiBogKB2bc+iHR+o+AULL1g5J1p1jsfU3ANLncShyyk4B08gVxC8RpUKUiDPMgmCNhmxmoToYKPYAgGoA1eQVO5L3Zjdwa8Bx3QBS0wAjVv+A1b2oCpgufgROvNgCNwoRxrljasVjjM5z82xJqZjdn1IWNN4ApfvE3EbYf2AVZOsJDni6/kF5pv7nJoP0rp8ivfAGUJOOQVePCGNk4wkb+JaenWr3EC/tjnhKH5PuZPgAEA6NNDiIh+vS8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/clubActivity/icons/delete_blue.png
// module id = 385
// module chunks = 440